<template>
  <div id="pageLoading" class="page-loading">
    <div id="defaultLoadingIcon">
      <div class="icon-point"></div>
      <div class="icon-point"></div>
      <div class="icon-point"></div>
      <div class="icon-point"></div>
      <div class="icon-point"></div>
      <div class="icon-point"></div>
      <div class="icon-point"></div>
      <div class="icon-point"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebLoading',
  data () {
    return {
    }
  }
}
</script>
<style>
  .page-loading{
    position: fixed;
    z-index: 100;
    background-color: #ffffff;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .page-loading #defaultLoadingIcon {
    position: relative;
    width: 50px;
    height: 50px;
  }

  .page-loading .icon-point {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background: #d8d8d8;
    position: absolute;
    animation: icon-point linear 0.8s infinite;
    -webkit-animation: icon-point linear 0.8s infinite;
  }
  .page-loading .icon-point:nth-child(1){
    left: 24px;
    top: 2px;
    animation-delay:0s;
    -webkit-animation-delay:0s;
  }
  .page-loading .icon-point:nth-child(2){
    left: 40px;
    top: 8px;
    animation-delay:0.1s;
    -webkit-animation-delay:0.1s;
  }
  .page-loading .icon-point:nth-child(3){
    left: 47px;
    top: 24px;
    animation-delay:0.1s;
    -webkit-animation-delay:0.1s;
  }
  .page-loading .icon-point:nth-child(4){
    left: 40px;
    top: 40px;
    animation-delay:0.2s;
    -webkit-animation-delay:0.2s;
  }
  .page-loading  .icon-point:nth-child(5){
    left: 24px;
    top: 47px;
    animation-delay:0.4s;
    -webkit-animation-delay:0.4s;
  }
  .page-loading .icon-point:nth-child(6){
    left: 8px;
    top: 40px;
    animation-delay:0.5s;
    -webkit-animation-delay:0.5s;
  }
  .page-loading .icon-point:nth-child(7){
    left: 2px;
    top: 24px;
    animation-delay:0.6s;
    -webkit-animation-delay:0.6s;
  }
  .page-loading .icon-point:nth-child(8){
    left: 8px;
    top: 8px;
    animation-delay:0.7s;
    -webkit-animation-delay:0.7s;
  }

  @keyframes icon-point
  {
    0%,40%,100% {transform: scale(1);}
    20% {transform: scale(3);}
  }
  @-webkit-keyframes icon-point
  {
    0%,40%,100% {transform: scale(1);}
    20% {transform: scale(3);}
  }
</style>



// WEBPACK FOOTER //
// src/components/web/loading.vue